var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 745.3 1280 407.2",
    enableBackground: "new 0 745.3 1280 407.2",
    xmlSpace: "preserve",
    width: 147.133,
    height: 46.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EB443F",
    d: "M0,745.3h1280.2c0,0,0,281,0,293.7 c-27.4,0-166.2,0-166.2,0v113.4l-1114,0V745.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M690.4,1097.9c10.6,0,11.7-10.4,11.7-10.4l0.1-1.3 c0,0-0.1-287,0-288.2c0.1-1.2-1.1-11.6-11.7-11.6c-10.6,0-27,0-38.1,0c-11.1,0-11.7,11.6-11.7,11.6s0.1,86,0,103.6 c-0.1,17.5-16.4,19.5-19.5,19.4c-2.2-0.1-132.2-0.1-133.6,0c-1.8,0.1-19.1-1.2-19.8-19.4c-0.1-18.1,0-102.5,0-103.6 s-1.2-11.5-12-11.6c-10.8,0-27.9,0-38.1,0c-10.1,0.3-11.7,9.5-11.7,11.6c0,2.1,0.5,276.6,0.5,276.6c-0.1,5.9,4.2,22.7,23.5,23.2 c21,0,63,0,68.4,0c6.6,0.3,22.3-4.2,23.5-23.2c0-20.7-0.2-75.8,0-78.6c0.2-2.8,1.4-19.4,20-19.4s61.9,0,79,0 c17.1,0,19.8,16.9,19.8,18.3c0,1.4-0.1,80.9-0.1,91.3c0.8,10.4,8.8,11.6,11.9,11.6C655.3,1098,679.8,1098,690.4,1097.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M856.5,1097.9c2.5,0,23.5-1.8,23.5-23.2c0-21.4,0-109.7,0-109.7 l-52.8-52.6c0,0,0-113.6,0-114.3c0.3-0.9-0.8-11.4-11.8-11.6c-10.9-0.1-28.5-0.1-39.2,0c-10.7,0.5-12.1,9.6-12.1,11.6 c0,2-0.1,273.2,0,276.6c-0.3,5.6,4.1,23.1,23.2,23.2C808.6,1098,854,1098,856.5,1097.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M1156.3,920.2c11.5-0.1,11.8-11.6,11.8-11.6v-56.7 c0,0-0.5-11.6-11.8-11.6s-138.6,0-149.3,0s-11.8,10.6-11.8,11.6c0,1,0,56,0,56.7s0.4,11.8,11.8,11.6S1144.8,920.2,1156.3,920.2z  M1027.4,1097.9c-5.4,0-49.1-0.1-69.7,0c-20.6,0.1-23.7-19.6-23.6-23.2c-0.1-2.9,0-263.2,0-265c0-2.9,1.9-22.6,23.6-23.2 c21.9-0.1,247,0,247,0c17.2,0.2,23.8,15.4,23.6,23.2c0,0,0.1,137.1,0,142.8c-0.1,5.8-3,22.4-23.6,23.3c-21.1,0-115.9,0-133.8,0 c-17.8,0.8-19.8,16.4-19.8,19.4c0,3,0,58.1,0,79.4C1049.5,1095.5,1033.7,1097.9,1027.4,1097.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M75.1,786.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M344.1,878.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "51.8,809.8 51.8,833 51.8,833.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M344.2,1074.7c-1,20-15,23.2-23.2,23.2c-8.2,0-243.5-0.1-245.8,0c-2.4,0.3-23.1-2.3-23.2-23.2 c-0.1-21,0-161.1-0.1-241.7v-23.2c1.6-22.2,20-23.2,22.9-23.3h0.3c46.1,0,90,0,92.2,0c60.2,0,152,0,153.5,0h0.2 c10.3,0,23.2,7.8,23.2,23.4c0,22.8,0,68.8,0,69c-1,11.3-11.5,11.4-11.6,11.4h-37.5c-11.8-1-11.6-11.6-11.6-11.6l-0.1-17.1 c0,0,0.9-19.4-20.4-20.2c-19.8,0.1-129.3,0.2-130.1,0.1c-1.8,0-18.7,1.1-19.4,19.4c-0.1,18.5,0,51,0,51l52.8,52.3 c0,0-0.1,55.2,0,58.8c-0.2,3.7,2.1,17.8,17.7,19.3c14.6,0.1,75.5,0.1,80.2,0.1c4.7,0,18.8-3.1,19.4-19.4c0.2-3.4,0-5.6,0.2-11.6 c0.2-6,2.7-12.7,11.4-13.1c14.1,0,26.6-0.1,37.5,0c11,0.6,11.7,10.5,11.6,11.6C344.1,1011,344.3,1055.1,344.2,1074.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.602b6a06e3a5d2cb99e2cc6dca6818c5.svg";
export { ForwardRef as ReactComponent };